import { useState } from 'react';
import { Card } from '../components/ui/card';

export const GUIDES = [
  { id: 'moc', title: 'Créer une MOC', img: '/aide/new_moc.jpg', color: 'bg-emerald-600', steps: [
    ['Menu « Nouvelle MOC »', 'Bouton en haut à droite ou menu latéral.'],
    ['Décrire', 'Titre, site, service, description et justification.'],
    ['Classer', 'Catégorie et nature du changement.'],
    ['Soumettre', 'La MOC part dans le circuit d\'approbation.'],
  ] },
  { id: 'sid', title: 'Remplir Safety In Design', img: '/aide/detail_safety.jpg', color: 'bg-rose-600', steps: [
    ['Ouvrir la fiche MOC', 'Onglet « Safety In Design ».'],
    ['Répondre', 'Oui / Non / N/A + commentaire pour chaque point.'],
    ['Créer l\'action', 'Sur un « Non », bouton « Créer une action ».'],
    ['Enregistrer', 'Bouton « Enregistrer » en haut à droite.'],
  ] },
  { id: 'nc', title: 'Traiter les non conformités', img: '/aide/sid_nc.jpg', color: 'bg-rose-600', steps: [
    ['Repérer', 'Badge rouge « X SiD » dans Mes MOC ou KPI du tableau de bord.'],
    ['Cliquer le badge', 'Ouvre directement la vue des écarts.'],
    ['Filtrer', 'Bouton « Non conformités » = seulement les « Non ».'],
    ['Exporter', 'Bouton « Rapport PDF » : check-list + plan d\'actions.'],
  ] },
  { id: 'pssr', title: 'Importer un PSSR Word', img: '/aide/pssr_import.jpg', color: 'bg-cyan-600', steps: [
    ['Page PSSR', 'Bouton « Importer un PSSR (Word) ».'],
    ['Choisir le .docx', 'Tableaux « Actions avant/après mise en route » lus automatiquement.'],
    ['Vérifier', 'Responsable et date de chaque action, décochez si besoin.'],
    ['Importer', 'Rattachez à une MOC existante ou nouvelle.'],
  ] },
  { id: 'admin', title: 'Gérer utilisateurs & sites', img: '/aide/admin_sites.jpg', color: 'bg-amber-500', steps: [
    ['Administration', 'Réservé aux administrateurs site / national.'],
    ['Utilisateurs', '« Nouvel utilisateur » puis attribuer les rôles par site.'],
    ['Sites', '« Nouveau site », crayon pour modifier, « Désactiver ».'],
    ['Rappels', 'Onglet « Rappels » : délai J-N, heure, copie au pilote.'],
  ] },
];

export const GuideViewer = () => {
  const [active, setActive] = useState(GUIDES[0].id);
  const g = GUIDES.find((x) => x.id === active);
  return (
    <Card className="rounded-sm p-5" data-testid="aide-guides">
      <h2 className="font-display font-bold text-lg">Guides pas à pas</h2>
      <div className="flex flex-wrap gap-2 mt-3">
        {GUIDES.map((x) => (
          <button key={x.id} data-testid={`aide-guide-tab-${x.id}`} onClick={() => setActive(x.id)}
            className={`px-3 py-1.5 text-sm rounded-sm border transition-colors ${active === x.id ? 'bg-primary text-primary-foreground border-primary' : 'border-border hover:bg-muted'}`}>
            {x.title}
          </button>
        ))}
      </div>
      <div className="grid lg:grid-cols-[1.6fr_1fr] gap-5 mt-5" data-testid={`aide-guide-${g.id}`}>
        <img src={g.img} alt={g.title} className="w-full rounded-sm border border-border shadow-sm" />
        <ol className="space-y-4">
          {g.steps.map(([t, d], i) => (
            <li key={t} className="flex gap-3">
              <span className={`${g.color} text-white w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm shrink-0`}>{i + 1}</span>
              <div>
                <div className="font-semibold text-sm">{t}</div>
                <div className="text-sm text-muted-foreground">{d}</div>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </Card>
  );
};

const FLOW = ['Création', 'Classification', 'Approbations', 'Safety In Design', 'Actions & Risques', 'PSSR', 'Clôture'];

export const MocFlow = () => (
  <Card className="rounded-sm p-5" data-testid="aide-flow">
    <h2 className="font-display font-bold text-lg">Le parcours d'une MOC</h2>
    <div className="flex flex-wrap items-center gap-2 mt-4">
      {FLOW.map((f, i) => (
        <div key={f} className="flex items-center gap-2">
          <div className={`flex items-center gap-2 px-3 py-2 rounded-sm text-sm font-semibold ${f === 'Safety In Design' ? 'bg-rose-50 text-rose-700 border border-rose-200' : 'bg-muted'}`}>
            <span className="w-6 h-6 rounded-full bg-primary text-primary-foreground text-xs flex items-center justify-center">{i + 1}</span>
            {f}
          </div>
          {i < FLOW.length - 1 && <span className="text-muted-foreground">→</span>}
        </div>
      ))}
    </div>
  </Card>
);
